// Tiny fetch wrapper — same-origin, cookie credentials, JSON.
export async function api<T = unknown>(
  path: string,
  opts: RequestInit = {},
): Promise<{ ok: boolean; status: number; data: T }> {
  const headers: Record<string, string> = { ...(opts.headers as Record<string, string>) };
  if (opts.body && !headers['Content-Type']) headers['Content-Type'] = 'application/json';
  const res = await fetch(path, { credentials: 'include', ...opts, headers });
  let data = null as unknown as T;
  try {
    data = (await res.json()) as T;
  } catch {
    /* no body */
  }
  return { ok: res.ok, status: res.status, data };
}
